// extracted by mini-css-extract-plugin
export default {"wrapper":"Task_wrapper__zvx3s","text":"Task_text__IwwM2","btn":"Task_btn__5Zeie","checkbox":"Task_checkbox__XsrPA"};